import { getAsLongDateTime } from '../../../common-client2/src/services/ukgDateTime';
import { getRequestTypeLabel } from '../../Enums/Helpers/LabellingHelper';
import { TypeOfPeriod } from '../../Enums';

export const mapManagerSettings = (managerList, hyperFindList, t, settingsForManager) => {
    const settingsForManagerById = Object.fromEntries(settingsForManager.map(s => [s.id, s]));

    return managerList.map((i) => {
        const autoApproval = i.adminSettings[0].autoApproval;

        const requestTypeLabel = getRequestTypeLabel(i.type);
        const approvalProcessLabel = autoApproval ? t('settings.automatic') : t('settings.manual');
        const hyperfindLabel = hyperFindList.find(hl => hl.value === i.hyperfindSettings[0].hyperfindId)?.label || '';

        const submissionPeriodLabel = i.toCoverPeriod_TypeOfPeriod === TypeOfPeriod.Range
            ? `${getAsLongDateTime(i.toCoverPeriod_StartDate)} - ${getAsLongDateTime(i.toCoverPeriod_EndDate)}`
            : t('form.forever');

        const requestPeriodLabel = i.requestPeriod_TypeOfPeriod === TypeOfPeriod.Range
            ? `${getAsLongDateTime(i.requestPeriod_StartDate)} - ${getAsLongDateTime(i.requestPeriod_EndDate)}`
            : i.requestPeriodLimitInDays === null ? t('form.forever') : t('form.foreverWithLimit', { numberOfDays: i.requestPeriodLimitInDays });

        const setupLabels = i.adminSettings
            .filter(a => settingsForManagerById[a.adminSettingsId])
            .map(a => settingsForManagerById[a.adminSettingsId].name);

        return {
            ...i,
            requestTypeLabel,
            approvalProcessLabel,
            hyperfindLabel,
            submissionPeriodLabel,
            requestPeriodLabel,
            setupLabels
        };
    });
};
